export default __webpack_public_path__ + "static/media/edit-profile.a014678d.svg";